import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { ExperienceVerificationStatusType, ExperienceVerificationStatusTypeOptions } from '@apply/constants';
import { formatExperienceAddress } from './formatExperienceAddress';
import { isMobileScreen } from '@apply/ui';

export const formatExperienceAddressWithStatus = (experience: UserExperienceDto) => {
    const mobileScreen = isMobileScreen();
    const verificationStatus = ExperienceVerificationStatusTypeOptions.find(
        (vs) => vs.id === experience.verificationStatusTypeId
    );
    const displayStatus =
        experience.verificationStatusTypeId == ExperienceVerificationStatusType.UnableToVerify ||
        experience.verificationStatusTypeId == ExperienceVerificationStatusType.Rejected;

    return (
        <span className='experience-grid-address'>
            <span>{formatExperienceAddress(experience)}</span>{' '}
            {displayStatus && (
                <>
                    {mobileScreen && <br />}
                    <span className={`experience-grid-address-status ${mobileScreen ? 'mobile' : ''}`}>
                        {verificationStatus?.name}
                    </span>
                </>
            )}
        </span>
    );
};
